import { Box, Avatar } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { selectRequesting } from "../../../selectors/requesting/RequestingSelector";
import jwtDecode from "jwt-decode";
import { useTheme } from "@mui/material";
import UserAction from "../../../stores/user/UserAction";

const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [UserAction.REQUEST_USER_BY_ID]),
  user: state.user.user || [],
});

function AvatarIcon(props) {
  // fetch function
  function fetch(id) {
    props.dispatch(UserAction.requestUser());
  }

  const theme = useTheme();

  React.useEffect((event) => {
    const auth = jwtDecode(localStorage.getItem("Auth"));
    fetch(auth.sub);
  }, []);

  let FirstLetter = props.user._source ? props.user._source.firstName : "";

  return (
    <Box>
      <Avatar
        alt="Remy Sharp"
        sx={{ cursor: "pointer", backgroundColor: theme.palette.primary.main }}
      >
        {props.user._source ? <h3>{FirstLetter?.slice(0, 1)}</h3> : ""}
      </Avatar>
    </Box>
  );
}

export default connect(mapStateToProps)(AvatarIcon);
